import script from "./PerfilPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilPanel.vue?vue&type=script&setup=true&lang=js"

import "./PerfilPanel.vue?vue&type=style&index=0&id=16b0f6d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b0f6d1"]])

export default __exports__